/**
 * Firestore'da para KURUŞ (integer) olarak saklanır. Arayüz sınırında çevrilir.
 * Bileşenlerde asla elle `/100` yapma — buradaki fonksiyonları kullan.
 */

const TL = new Intl.NumberFormat("tr-TR", {
  style: "currency",
  currency: "TRY",
  minimumFractionDigits: 2,
});

const NUM = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 });

export function tl(kurus: number | null | undefined): string {
  if (kurus === null || kurus === undefined || !Number.isFinite(kurus)) return "—";
  return TL.format(kurus / 100);
}

export function n(v: number | null | undefined, suffix = ""): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  return NUM.format(v) + suffix;
}

export function pct(v: number | null | undefined): string {
  return v === null || v === undefined || !Number.isFinite(v) ? "—" : `%${NUM.format(v)}`;
}

const DT = new Intl.DateTimeFormat("tr-TR", {
  day: "2-digit", month: "2-digit", year: "numeric",
  hour: "2-digit", minute: "2-digit",
});

const D = new Intl.DateTimeFormat("tr-TR", {
  day: "2-digit", month: "2-digit", year: "numeric",
});

/**
 * `unknown` kabul eder: Firestore'dan gelen alanlar tip sisteminde çoğu zaman
 * `unknown`/`{}` görünüyor ve her çağrı yerinde cast yaptırmak, tarih olmayan
 * bir değerin sessizce geçmesine yol açardı. Dönüşüm burada, tek yerde korunur.
 */
type TimestampLike = unknown;

function toDate(v: TimestampLike): Date | null {
  if (v === null || v === undefined) return null;
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  if (typeof v === "number") return Number.isFinite(v) ? new Date(v) : null;
  if (typeof v === "string") {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof v === "object" && typeof (v as { toDate?: unknown }).toDate === "function") {
    const d = (v as { toDate: () => Date }).toDate();
    return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
  }
  return null;
}

export function dt(v: TimestampLike): string {
  const d = toDate(v);
  return d ? DT.format(d) : "—";
}

export function date(v: TimestampLike): string {
  const d = toDate(v);
  return d ? D.format(d) : "—";
}

/** "3 gün önce" — üretim kuyruğunda bekleme süresini görünür kılar. */
export function since(v: TimestampLike): string {
  const d = toDate(v);
  if (!d) return "—";
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "az önce";
  if (mins < 60) return `${mins} dk önce`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} saat önce`;
  const days = Math.floor(hours / 24);
  return `${days} gün önce`;
}
